
export const TradeDetailQuantity = "tfTradeDetailQuantity";

export function tradeDetailQuantity() {
    return {
        template,
        bindings: {
            trade: "<",
            onChange: "&"
        },
        controller: TradeQuantityController,
        controllerAs: "ctrl"
    };
}

export class TradeQuantityController {
    public trade: Trade;
}

export const template = `
    <div class="row form-group">
        <label class="col-sm-2 control-label" style="margin-top: 6px;">Qty</label>
        <div class="col-sm-10">
            <input id="qty"
                   type="number"
                   class="form-control"
                   name="Quantity"
                   ng-model="ctrl.trade.quantity"
                   ng-required="true"
                   value-not-zero="quantity"
                   ng-change="ctrl.onChange()"
                   ng-model-options="{ updateOn: 'default blur', debounce: {'default': 500, 'blur': 0} }">
        </div>
    </div>
`;
